/**
 * Transforme un objet JS de style en string CSS utilisable dans un attribut HTML.
 * @param {Object} styleObj - L'objet style JS (camelCase).
 * @returns {string} - La chaîne CSS.
 */
const styleObjectToCss = (styleObj) => {
    return Object.entries(styleObj)
        .map(([key, value]) => {
            // Convertit camelCase en kebab-case
            const cssKey = key.replace(/[A-Z]/g, m => '-' + m.toLowerCase());
            return `${cssKey}:${value}`;
        })
        .join('; ');
}

/**
* Génère une balise <div> HTML avec un style inline.
* @param {Object} styleObj - L'objet style JS.
* @returns {string} - Le HTML généré.
*/
export const generateStyledDiv = (styleObj) => {
    const styleStr = styleObjectToCss(styleObj);
    return `<div style="${styleStr}"><br></div>`;
}

/**
 * Créer un elipsis a partir d'un certain nombre de caractères, en comptant les majuscules pour 1.5.
 * @param {string} text - Le texte à traiter.
 * @param {number} maxLength - La longueur maximale du texte (avec majuscules comptées pour 1.5).
 * @returns {string} - Le texte avec un elipsis si nécessaire.
 */
export const createEllipsis = (text, maxLength) => {
    // Remplacer chaque majuscule par elle-même plus un espace pour compter comme 1.5 caractères
    const textWithDoubledUppercase = text.replace(/[A-Z]/g, match => match + ' ');
    
    if (textWithDoubledUppercase.length > maxLength) {
        // Trouver la position du dernier caractère qui ne dépasse pas maxLength
        let position = 0;
        let currentLength = 0;
        
        for (let i = 0; i < text.length; i++) {
            if (text[i] === text[i].toUpperCase() && text[i] !== text[i].toLowerCase()) {
                currentLength += 1.5; // Majuscule compte pour 1.5
            } else {
                currentLength += 1;
            }
            
            if (currentLength <= maxLength) {
                position = i;
            } else {
                break;
            }
        }
        
        return text.substring(0, position + 1) + '...';
    }
    return text;
}
